import axios from 'axios';

export async function GetStartlist(raceId, okFunc, errorFunc) {
    await axios.get(`${process.env.REACT_APP_APIBASE}/live-replay/race/${raceId}/`,
        { headers: { "Authorization": `Bearer ${process.env.REACT_APP_TRAIS_TOKEN}` } }
    )
        .then(res => {
            okFunc(res.data);
        })
        .catch(error => {
            errorFunc(error);
        });
}

export async function GetRace(date, trackId, raceNumber, okFunc, errorFunc) {
    await axios.get(`${process.env.REACT_APP_APIBASE}/live-replay/race/?track_id=${trackId}&race_number=${raceNumber}&date=${date}`,
        { headers: { "Authorization": `Bearer ${process.env.REACT_APP_TRAIS_TOKEN}` } }
    )
        .then(res => {
            okFunc(res.data);
        })
        .catch(error => {
            errorFunc(error);
        });
}

export async function GetRaces(date, trackId, okFunc, errorFunc) {
    await axios.get(`${process.env.REACT_APP_APIBASE}/live-replay/race/?track_id=${trackId}&date=${date}&limit=20`,
        { headers: { "Authorization": `Bearer ${process.env.REACT_APP_TRAIS_TOKEN}` } }
    )
        .then(res => {
            okFunc(res.data);
        })
        .catch(error => {
            errorFunc(error);
        });
}

export const StartClassName = (start, count, index) => {
    let baseClass = count > 13 ? "start-mini" : "start";
    if(index % 2 === 1)
        baseClass += " odd";
    if(start.scratched)
        return baseClass + " scratched clearfix";
    return baseClass + " clearfix";
}

export const ShowOnlyV75 = (classname, bettype, race) => {
    if((bettype === 'v75' && race.legs.some(r => r.bet_type === "V75")) || (bettype === 'v85' && race.legs.some(r => r.bet_type === "V85"))) {
        return classname;
    }
    return `${classname} hidden`;
}

export const AddBoldFont = (classname, isBold) => {
    if(isBold) {
        return `${classname} bold`;
    }
    return classname;
}

export const FormatVOdds = (start, result) => {
    if(start.scratched)
        return "";
    if(start.placement !== 1 && result)
        return "";

    return (start.odds.providers.ATG.V/100).toFixed(2).replace('.',',') + "%";
}

export const FormatV75Odds = (start, result) => {
    if(start.scratched)
        return "";
    if(start.placement !== 1 && result)
        return "";
    if(start.game_percent.providers.ATG.V75)
        return (start.game_percent.providers.ATG.V75.percent/100).toFixed(2).replace('.',',') + "%";
    if(start.game_percent.providers.ATG.V85)
        return (start.game_percent.providers.ATG.V85.percent/100).toFixed(2).replace('.',',') + "%";
    return "";
}

export const FormatPOdds = (start) => {
    if(start.scratched)
        return "";
    return (start.odds.providers.ATG.P/100).toFixed(2);
}

export const SortBettype = ( a, b ) => {
    if ( a.bet_type < b.bet_type ){
      return 1;
    }
    if ( a.bet_type > b.bet_type ){
      return -1;
    }
    return 0;
  }

  export const DisplayTrackName = (race, bettype) => {
    if(bettype === 'v75') {
        let leg = race.legs.find(l => l.bet_type === 'V75');
        if(leg)
            return `V75-${leg.leg}`;
    }
    if(bettype === 'v85') {
        let leg = race.legs.find(l => l.bet_type === 'V85');
        if(leg)
            return `V85-${leg.leg}`;
    }
    return `Lopp ${race.race_number}`;
  }

  export const FriendlySpeed = (speed) => {
    const totalSeconds = speed/100;

    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds - minutes * 60;
    const rounded = Math.round(seconds*10)/10;
    const fixed = rounded.toFixed(1).replace('.',',');

    const finalTime = minutes + '.' + pad(fixed,4);
    return finalTime;
}

export const TrimByChar = (txt, length, char) => {
    if(txt.length > length) {
        let charTrim = txt;
        if(txt.indexOf(char) > -1) {
            charTrim = txt.substring(0, txt.indexOf(char));
        }
        return charTrim.substring(0, length);
    }
    return txt;
}

function pad(num, size) {
    var s = "000000000" + num;
    return s.substr(s.length-size);
}